export interface TileTag {
  id: string;
  name: string;
  color?: string;
}

/**
 * Resolves a record's tag ids against the organization's tag list, keeping the
 * order the ids were given in and dropping ids with no matching tag.
 *
 * How many of the resolved tags actually fit is decided at render time by
 * `TileTagList`, from the width it is given.
 */
export const resolveTileTagsByIds = <T extends TileTag>(
  tagIds: string[] | null | undefined,
  allTags: T[]
): T[] =>
  (tagIds ?? []).reduce<T[]>((acc, tagId) => {
    const tag = allTags.find(({ id }) => id === tagId);

    if (tag) {
      acc.push(tag);
    }

    return acc;
  }, []);
